<ng-container *ngIf="isBrowser">
<div *ngIf="warning$ | async as warning"
        class="sticky top-0 z-[9999] w-full border-b border-amber-200 bg-amber-50 text-amber-900">
    <div class="mx-auto flex max-w-6xl items-start gap-3 px-4 py-3">
        <!-- icon -->
        <svg class="mt-0.5 h-5 w-5 shrink-0 text-amber-600" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.721-1.36 3.486 0l6.516 11.59c.75 1.335-.214 2.991-1.743 2.991H3.484c-1.53 0-2.493-1.656-1.743-2.991L8.257 3.1zM11 14a1 1 0 10-2 0 1 1 0 002 0zm-1-8a1 1 0 00-1 1v4a1 1 0 102 0V7a1 1 0 00-1-1z" clip-rule="evenodd"/>
        </svg>

        <div class="flex-1 text-sm leading-5">
            <div class="font-medium">{{ warning.title }}</div>
            <div class="mt-0.5 text-amber-800">{{ warning.body }}</div>
        </div>

        <button *ngIf="warning.showRefresh"
                type="button"
                class="rounded-lg bg-amber-600 px-3 py-1.5 text-sm font-semibold text-black shadow-sm ring-2 ring-amber-500"
                (click)="refresh()">
            Refresh
        </button>
    </div>
</div>
</ng-container>

<vsf-preview-mode-banner *ngIf="showPreviewBanner"></vsf-preview-mode-banner>
<vsf-review-mode-banner *ngIf="showReviewBanner"></vsf-review-mode-banner>

<ng-container *ngIf="!isPublished && !previewAccessGranted; else returnFormMode">
    <vsf-under-construction-page></vsf-under-construction-page>
</ng-container>

<ng-template #returnFormMode>
    <ng-container *ngIf="showReturnForm !== undefined; else loading">
        <vsf-layout *ngIf="showReturnForm; else regularPageLayout">
            <router-outlet></router-outlet>
        </vsf-layout>
    </ng-container>
</ng-template>

<ng-template #regularPageLayout>
    <vsf-layout *ngIf="(readyToDisplay$ | async) && (uiState.isMobile !== null)">
        <vsf-layout-header style="position: relative; min-height: 60px;" id="page-header">
            <!-- top promotion message -->
            <div *ngIf="!uiState.isMobile; else storeMobileHeader">
                <div *ngIf="uiState.displayHeaderMessage && pageMessages?.headerMessageConfig?.messageList?.length > 0">
                    <vsf-header-messages
                        [config]="pageMessages?.headerMessageConfig"
                        [textColor]="storeColor?.headerFontColor"
                        [backgroundColor]="storeColor?.headerBackgroundColor"
                    >
                    </vsf-header-messages>
                </div>
                <div *ngIf="uiState.displayHeaderMenu && storeInfo.identifier"
                    class="bg-white max-w-6xl mx-auto px-2 py-2 items-center justify-between"
                    style="min-height: 60px;">
                    <div class="flex flex-row">
                        <vsf-store-logo class="flex-shrink-0 my-auto"
                            [normalLogo]="storeLogoConfig.normalLogo"
                            [nameLogo]="storeLogoConfig.nameLogo"
                            [smallLogo]="storeLogoConfig.smallLogo"
                            [name]="storeInfo.name"
                            [path]="[baseUrl]"
                            [logoHeight]="'50px'"
                            [displayName]="storeLogoConfig.displayName"
                            [isMobile]="uiState.isMobile"
                        >
                        </vsf-store-logo>
                        <div class="nav-menus flex items-center space-x-4 ml-auto">
                            <nav *ngIf="storeNavMenu.length > 0" class="py-2 flex flex-row">
                                <div *ngFor="let item of storeNavMenu" class="flex items-center">
                                <button (click)="navigateToPage(item)" class="nav-banner-button">{{ item.label }}</button>
                                </div>
                            </nav>
                        </div>
                        <div class="grid grid-cols-3 col-span2 ml-2 justify-end items-center gap-x-2  flex-shrink-0">
                            <vsf-product-search-bar class="z-20"></vsf-product-search-bar>
                            <vsf-cart-toggle class="z-10" (toggle)="openCartDrawer()"></vsf-cart-toggle>
                            <vsf-account-button *ngIf="!hideAccount" class="text-[#2E3742] text-lg z-10"
                            ></vsf-account-button>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #storeMobileHeader>
                <ng-container *ngIf="uiState.displayHeaderMenu">
                    <div class="flex flex-row justify-center pt-4 pb-2 bg-white" style="min-height: 60px;">
                        <div class="grid grid-cols-2 justify-center items-center gap-x-6">
                            <button id="navButton" class="nav-button ml-3" (click)="toggleMobileMenu()">
                                <svg class="size-5 text-grey-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                                </svg>
                            </button>
                            <vsf-product-search-bar class="z-20"></vsf-product-search-bar>
                        </div>
                        <div class="flex flex-grow felx-grow items-center justify-center">
                            <vsf-store-logo
                                [normalLogo]="storeLogoConfig.normalLogo"
                                [nameLogo]="storeLogoConfig.nameLogo"
                                [smallLogo]="storeLogoConfig.smallLogo"
                                [name]="storeInfo.name"
                                [path]="[baseUrl]"
                                [logoHeight]="'50px'"
                                [displayName]="storeLogoConfig.displayName"
                                [isMobile]="uiState.isMobile"
                            >
                            </vsf-store-logo>
                        </div>
                        <div class="grid grid-cols-2 justify-center items-center gap-x-6">
                            <vsf-cart-toggle class="z-10" (toggle)="openCartDrawer()"></vsf-cart-toggle>
                            <vsf-account-button *ngIf="!hideAccount" class="text-[#2E3742] text-lg z-10"
                            ></vsf-account-button>
                        </div>
                    </div>
                    <hr>
                    <div *ngIf="uiState.isNavExpanded && uiState.isMobile" class="bg-white nav-container">
                        <div class="flex justify-center items-center">
                            <nav *ngIf="storeNavMenu.length > 0" class="mx-auto py-2 flex flex-row justify-between">
                                <div *ngFor="let item of storeNavMenu" class="flex items-center">
                                    <button (click)="navigateToPage(item)" class="nav-banner-button">{{item.label}}</button>
                                </div>
                            </nav>
                        </div>
                    </div>
                </ng-container>
            </ng-template>
            <hr>
        </vsf-layout-header>

        <!-- Cart Drawer -->
        <div *ngIf="hydratedInBrowser && uiState.isForStore">
            <vsf-cart-drawer
                (close)="closeCartDrawer()"
                [storeIdentifier]="storeInfo?.identifier"
                [visible]="(cartDrawerVisible$ | async) === true">
            </vsf-cart-drawer>
        </div>

        <!-- Mobile menu overlay -->
        <div *ngIf="hydratedInBrowser && uiState.isMobile && uiState.isForStore && orderStatusHref">
            <vsf-mobile-menu-overlay
                [isOpen]="uiState.isNavExpanded"
                [navMenu]="storeNavMenu"
                [mobileSecondaryNavMenu]="mobileSecondaryNavMenu"
                [orderStatusHref]="orderStatusHref"
                (onClose)="closeMobileMenu()"
                (onNavigate)="navigateToPage($event)"
                (onContactUs)="handleAction('Contact Us')"
            ></vsf-mobile-menu-overlay>
        </div>

        <!-- Page Content -->
        <div class="max-w-6xl mx-auto" [ngStyle]="{'min-height': uiState.isMobile ? '800px' : '1200px'}">
            <router-outlet></router-outlet>
        </div>

        <!-- Page Footer -->
        <vsf-layout-footer *ngIf="uiState.displayFooterMenu && navigationColumns?.length > 0" style="min-height: 425px;">
            <vsf-page-footer
                [navigationColumns]="navigationColumns"
                [storeLogo]="storeLogoConfig.normalLogo"
                [footerLogo]="storeLogoConfig.footerLogo"
                [isMobile]="uiState.isMobile"
                [snsInfo]="storeInfo.snsInfo"
                [baseUrl]="baseUrl"
                [supportEmail]="storeInfo.supportEmail"
                [orderStatusHref]="orderStatusHref"
                [storeColor]="storeColor"
                [disclaimer]="pageMessages?.disclaimer"
                [copyrightNotice]="pageMessages?.copyrightNotice"
            >
            </vsf-page-footer>
        </vsf-layout-footer>
    </vsf-layout>
</ng-template>
<ng-container *ngIf="fullscreenPreviewOpen$ | async">
    <vsf-vimeo-fullscreen-preview
        [videoId]="vimeoVideoId"
        (close)="closeFullscreenPreview()">
    </vsf-vimeo-fullscreen-preview>
</ng-container>

<!-- Loading Placeholder -->
<ng-template #loading>
    <p>{{showReturnForm}}</p>
    <p>Loading...</p>
</ng-template>